export default function Settings () {

    return (
        <div className={'border rounded-md mt-6 overflow-hidden p-6'}>
            <div className="text-3xl font-bold text-slate-700">
                Integra BeDirect nel tuo sito web
            </div>
            <div className="text-slate-600 text-lg mt-4">
                integrare lo script di BeDirect nel tuo sito web è semplice e non richiede sviluppo particolare. Si integra
                come qualsiasi altro script di marketing (es: Google Analytics, Pixel di Facebook e similari)
            </div>
        </div>
    )

}
